import baseRoute from '../baseRoute';

type RouteDefinition = `${typeof baseRoute}/${number | ':id'}/activate`;

export const ROUTE: RouteDefinition = `${baseRoute}/:id/activate`;

export const URL = (id: number): RouteDefinition => `${baseRoute}/${id}/activate`;
